import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  initializeSections,
  setIsLoadingUnitStatus,
  setPopupState,
} from '../../model/configuratorSlice';
import SummarySectionsListMobile from './SummarySectionsListMobile';
import IsNullOrUndefined from '../../utils/ObjectUtils';
import { PopupState } from '../../model/constants';
import DownloadPdfService from '../../services/DownloadPdfService';
import { hasContactFormBeenSent } from '../../utils/contactFormStorage';

const SummaryPanelMobile = () => {
  const {
 settings, isSummaryOpened, summaryShots, currentUnit,
} = useSelector(state => state.configurator);
  const [topShot, setTopShot] = useState(null);
  const [bottomShot, setBottomShot] = useState(null);

  const dispatch = useDispatch();
  const { promotionSlug } = useParams();

  const downloadPdfMutation = DownloadPdfService();

  useEffect(() => {

  }, [summaryShots]);

  useEffect(() => {
    dispatch(initializeSections());

    if (summaryShots != null && summaryShots.length === 2) {
      setTopShot(summaryShots[0]);
      setBottomShot(summaryShots[1]);
    }
  }, [isSummaryOpened]);

  useEffect(() => {

  }, [summaryShots]);

  return (
    <div className={`summary-panel-mobile ${isSummaryOpened ? 'opened' : ''}`}>
      <div className="summary-content">


        <SummarySectionsListMobile />
        <div className="summary-buttons-container">
          {!IsNullOrUndefined(currentUnit) ? (
            <>
              <button
                className="request-budget-button"
                type="button"
                onClick={() => {
                  dispatch(setIsLoadingUnitStatus(true));
                  dispatch(setPopupState(PopupState.RequestBudget));
                }}
              >
                <span>Formalizar</span>
              </button>
              <button
                className="save-button"
                type="button"
                onClick={() => {
                  if (!IsNullOrUndefined(currentUnit)) {
                    dispatch(setIsLoadingUnitStatus(true));
                    dispatch(setPopupState(PopupState.CheckForSaveConfiguration));
                  }
                }}
              ><span>Guardar configuración</span>
              </button>
            </>

          ) : (
            !hasContactFormBeenSent(promotionSlug) && (
              <button
                className="contact-us-button"
                type="button"
                onClick={() => dispatch(setPopupState(PopupState.ContactUs))}
              >
                <span>Contacta con nosotros</span>
              </button>
            )
          )}
          <button
            className="download-button"
            type="button"
            onClick={() => {
              if (!IsNullOrUndefined(currentUnit)) {
                dispatch(setIsLoadingUnitStatus(true));
                dispatch(setPopupState(PopupState.CheckForDownloadPdf));
              } else if (hasContactFormBeenSent(promotionSlug)) {
                downloadPdfMutation.mutate();
              } else {
                dispatch(setPopupState(PopupState.CheckForContactBeforeDownload));
              }
            }}
          ><span>Descargar Resumen</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SummaryPanelMobile;
